import { flatten } from 'lodash';
import { ILexiconRuleConditionsGroupDraft } from '../LexiconRuleForm.types';

export function getUniqueCategoriesFromConditionsGroups(
  conditionsGroups: ILexiconRuleConditionsGroupDraft[]
) {
  return [
    ...new Set(
      flatten(
        conditionsGroups.map(conditionGroup =>
          conditionGroup.conditions.map(condition => condition.categoryKey)
        )
      )
    ),
  ];
}
